module.exports = __webpack_public_path__ + "img/university-police-logo.d4bd078c.jpg";